import { render, staticRenderFns } from "./questionOrManualDetail.vue?vue&type=template&id=5bc7d6cb&scoped=true"
import script from "./questionOrManualDetail.vue?vue&type=script&lang=js"
export * from "./questionOrManualDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc7d6cb",
  null
  
)

export default component.exports